export const GET_NEWS_REQUEST = "GET_NEWS_REQUEST"
export const GET_NEWS_REQUEST_SUCCESS = "GET_NEWS_REQUEST_SUCCESS"
export const GET_NEW_REQUEST = "GET_NEW_REQUEST"
export const GET_NEW_REQUEST_SUCCESS = "GET_NEW_REQUEST_SUCCESS"

export const DELETE_NEWS_REQUEST = "DELETE_NEWS_REQUEST"
export const DELETE_NEWS_REQUEST_SUCCESS = "DELETE_NEWS_REQUEST_SUCCESS"

